import { i18nTranslate } from '@didi/i18n-plugin';

export const sortMap: any = {
  ascend: 'asc', // 升序
  descend: 'desc' // 降序
};

/* eslint-disable no-unused-vars */
export enum DayBtnType {
  last_7_day = 1, // 近7天
  this_week = 2, // 这周
  last_week = 3, // 上周
  this_month = 4, // 这月
  other = 0
}

export enum ErrnoType {
  ErrNoPermission = 10003, // 账号无权限
  ErrUSerNoExist = 10004, // 非OPS注册账号
  ErrTicketInvalid = 10005, // 账号ticket过期
  ErrUserAccountDelete = 10006, // 账号已删除
  ErrUserAccountFreeze = 10007, // 账号已冻结
  Success = 0 // 接口通
}

export enum ErrHandleType {
  noCatch = 1, // 统一处理， 不抛出给业务代码异常.
  noCatch_hideErr = 2, // 统一处理， 并抛出异常，业务代码自行处理。
  catch_hideErr = 3, // 隐藏异常，不统一处理，不抛出给业务代码异常.
  catch = 4 // 不统一处理，抛出异常，业务代码自行处理。
}

// 订单状态
export enum OrderStateType {
  Payment = 3, // 已完成
  Cancel = 4, // 已取消
  Refund = 10 // 已退款
}

// 油品上下架状态
export enum StatusType {
  Listed = 1, // 上架
  Delisted = 2 // 下架
}

// 油站上架/下架/测试状态
export enum StationStatusType {
  Listed = 1, // 已上架
  Delisted = 2, // 已下架
  Test = 3 // 上架测试中
}

// 编辑 or 上架油品
export enum OperationType {
  Edit = 'Edit', // 编辑
  Listed = 'Listed' // 上架
}

// 商品在RMS的状态
export enum RMSStatus {
  Active = 1, // 激活
  Inactive = 2 // 未激活
}

// 下架 油站/商品 的原因
export enum DelistReasonType {
  Other = 100 // 其他
}

// filter的类型
export enum ConditionType {
  RangeDate = 'RangeDate',
  SearchWord = 'SearchWord',
  MultiCascader = 'MultiCascader',
  Input = 'Input',
  Select = 'Select',
  MultiSelect = 'MultiSelect'
}

// 账单状态，1-待确认；2-审核中；3-驳回；4-已支付
export enum SettlementBillState {
  Pending = '1', // 待确认
  Auditing = '2', // 99审核中
  Rejected = '3', // 99驳回
  Paid = '4' // 99已支付
}

// 账单状态，1-待确认；2-审核中；3-驳回；4-已支付
export enum SettlementBillOriginState {
  MerchantConfirming = '1', // 商户确认中
  OperationApproving = '2', // 运营审批中
  BusinessOwnerApproving = '3', // business owner审批中
  FinancialApproving = '4', // 财务审批中
  ProoneApproving = '5', // proone审批中
  PaymentPreparing = '6', // 打款准备中
  PaymentCompleted = '7', // 打款已完成
  Rejected = '8' // 驳回
}

// 审批状态，1:待确认 2:审批中 3:驳回 4:审批通过
export enum ApprovalState {
  Pending = 1, // 待确认
  Auditing = 2, // 审批中
  Rejected = 3, // 驳回
  Paid = 4 // 审批通过
}

// 账单商品列表类型，1.真实商品; 2.调整项
export enum BillProductType {
  TrueProduction = 1, // 真实商品
  AdjustItem = 2, // 调整项
  Total = 3 // 99结算金额
}

// D/N发行方，1.平台; 2.油站
export enum DnChannel {
  Platform = 1, // 平台
  GasStation = 2 // 油站
}

// D/N发行方，0:无效; 1: 有效
export enum IfValid {
  Invalid = 0, // 无效
  Valid = 1 // 有效
}

// D/N or 支持性文件，1.上传 2、删除/撤销
export enum UpdateType {
  Upload = 1, // 上传
  Delete = 2 // 删除/撤销
}

// 审核节点，1.账单生成；2.商户确认中；3.99审核中；4.付款
export enum NodeCode {
  BillGeneration = '1', // 账单生成
  GSReview = '2', // 商户确认中
  PlatformReview = '3', // 99审核中
  Paid = '4' // 付款
}

// 账单详情中调整的类型，1:调整金额 2: 调整凭证D/N 3:其他
export enum AdjustType {
  AdjustAmount = 1, // 调整金额
  AdjustDn = 2, // 调整凭证D/N
  AdjustOther = 3 // 其他
}

// 驳回原因中拒绝金额的具体类型
export enum ApprovalRejectMoneyType {
  NO = 0, // 油站只提交了问题订单 或者 缺失订单 中的一项
  PROBLEMORDER = 1, // OPS拒绝问题订单
  MISSORDER = 2, // OPS拒绝缺失订单
  ALL = 3 // OPS拒绝all
}

export enum IsEdit {
  Edit = 1,
  NoEdit = 0
}

export enum AmountOperationType {
  Edit = 1,
  Clear = 2
}

export enum RangePickerChoiceType {
  Shortcut = 1, // 快捷选项
  Date = 2 // 日期范围
}

export enum PickerType {
  StartDate = 1, // 年月日（开始时间）
  StartTime = 2, // 时分秒（开始时间）
  EndDate = 3, // 年月日（结束时间）
  EndTime = 4 // 时分秒（结束时间）
}

// 与后端约定的特殊接口errno
export enum ErrorNo {
  NoError = 0, // 正常无报错返回的errno
  BeyondCountThreshold = 12001 // 问题订单编辑数量超出配置的值
}

/* eslint-enable no-unused-vars */

const PASSPORT_PAGE = 'https://page.didiglobal.com/public-biz/pc-login/3.1.2/index.html';
const appid = 200065;
const role = 5008;
const source = 70001;
const lang = 'pt-BR';
const REDIRECT_URL = encodeURIComponent(
  `${window.location.origin}/drvlab/web/setCookie?local=1&country=br&passport_role=${role}&country_path=${window.location.href}`
);
const passportBaseUrl = `${PASSPORT_PAGE}?appid=${appid}&role=${role}&source=${source}&lang=${lang}&redirectUrl=${REDIRECT_URL}`;

export const PASSPORT = {
  login: passportBaseUrl,
  logout: `${passportBaseUrl}#/logout`
};

/**
 * 二级栏
 * allRoute为所有二级栏对应子页面的router;
 * subRoute为点击二级栏出现的页面对应router;
 * children为二级栏下的三级栏，只会出现在面包屑展示中;
 */
export const getMenuMap = () => {
  const menuMap: any = {
    refuel_order: {
      subRoute: '/fuelOrder',
      allRoute: ['/fuelOrder']
    },
    refuel_bill: {
      subRoute: '/dlBill',
      allRoute: ['/dlBill']
    },
    order_rating: {
      subRoute: '/order_rating',
      allRoute: ['/order_rating', '/ratingDetail'],
      children: [
        {
          submenu_i18n: i18nTranslate('GDriver_0714_WCbg_WbRd'),
          submenu_name: '/ratingDetail'
        }
      ]
    },
    discount_setting: {
      subRoute: '/discountSetting',
      allRoute: ['/discountSetting']
    },
    discount_revise_records: {
      subRoute: '/discountRecord',
      allRoute: ['/discountRecord']
    },
    settlement: {
      subRoute: '/settlementBill',
      allRoute: ['/settlementBill', '/settlementDetail'],
      children: [
        {
          submenu_i18n: i18nTranslate('Internal_Tools_B_STXC_iwsY'),
          submenu_name: '/settlementDetail'
        }
      ]
    },
    no_permission: {
      subRoute: '/noPermission',
      allRoute: ['/noPermission']
    }
  };

  return menuMap;
};

export enum LocalStorageDic {
  isLogin = 'isLogin'
}

export enum BillType {
  MainBill = 0,
  AdjustBill = 1
}
